import { CustomPassengerName } from "./ticket";

export interface OrderData {
    id: string;
    ticketNumber: string;
    price: number;
    status: number;
    base64Aztec: string;
    purchaseDate: Date;
    issueDate: Date;
    validFrom: Date;
    validTo: Date;
    specialTicket: SpecialTicketData | null;
    validZones: number[];
    passengers: Passenger[];
}

export interface SpecialTicketData {
    id: string;
    ticketName: { [key: string]: string };
    ticketDescription: { [key: string]: string };
    ticketValidityText: { [key: string]: string };
    overriddenPassengerTypes: CustomPassengerName[]
}

export interface Passenger {
    type: string;
    count: number;
}

export enum OrderState {
    Ordered = 0,
    PaymentAuthorized = 1,
    Paid = 2,
    Refunded = 3,
    Cancelled = 4,
    Deactivated = 5,
    TransferredTooMuch = 6,
    Unknown = 7
}
